import { render, staticRenderFns } from "./DataTableRowHandler.vue?vue&type=template&id=9873f0c2&"
import script from "./DataTableRowHandler.vue?vue&type=script&lang=js&"
export * from "./DataTableRowHandler.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports